module.exports = __webpack_public_path__ + "static/media/idea_suggestion.6cfe4961.svg";